import { Fragment } from "react";
import { classNames } from "@circle-react/helpers/twMergeWithCN";
import type { PaywallCheckoutPreview } from "@circle-react/types";
import { CheckoutFormSection } from "../../../../CheckoutFormSection";
import { DEFAULT_FULL_PREVIEW_VARIANT } from "../../constants";
import type { PreviewComponents } from "../../types";
import { componentsByVariants } from "./variants";

export interface FirstPaymentPreviewProps {
  className?: string;
  preview: PaywallCheckoutPreview;
  variant?: keyof typeof DEFAULT_FULL_PREVIEW_VARIANT;
}

export const FirstPaymentPreview = ({
  className,
  preview,
  variant = DEFAULT_FULL_PREVIEW_VARIANT.default,
}: FirstPaymentPreviewProps) => {
  const variants =
    componentsByVariants[variant] ||
    componentsByVariants[DEFAULT_FULL_PREVIEW_VARIANT.default];

  const listOfComponents: PreviewComponents =
    variants[preview.paywall_price.price_type];

  return (
    <CheckoutFormSection className={classNames("gap-y-2", className)}>
      {/* eslint-disable-next-line sonarjs/no-uniq-key, sonarjs/pseudo-random -- Disabled for plugin version update. Fix when possible */}
      <Fragment key={Math.random()}>
        {listOfComponents.map(([component, getOptions]) =>
          component({ preview, options: getOptions(preview) || {} }),
        )}
      </Fragment>
    </CheckoutFormSection>
  );
};
